import {
  RadioButton,
  RadioButtonGroup,
  Tooltip,
} from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesValProps } from '../../MaximoJourneyAdvisor';
import { segmentsTracking } from 'src/common/lib/tracker';
import PublicImage from 'src/common/components/PublicImage';
import './Step.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/maximo-journey-advisor/locales/messages';
import { primaryIndustryOption } from 'src/apps/maximo-journey-advisor/constants/default';

type Step1Props = {
  que1Value: string;
  q1Img: string;
  setQ1Img: React.Dispatch<React.SetStateAction<string>>;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesVal: React.Dispatch<React.SetStateAction<QuesValProps>>;
  trackQuesVal: QuesValProps;
};

const Step1 = ({
  que1Value,
  setQue1Value,
  setIsRequired,
  setTrackQuesVal,
  trackQuesVal,
  q1Img,
  setQ1Img,
}: Step1Props) => {
  const intl = useIntl();
  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue1Value(value);
    setIsRequired(false);
    setTrackQuesVal({
      ...trackQuesVal,
      Q1: value,
    });
    setQ1Img(`images/${(event.target as HTMLInputElement).id}.jpg`);
    segmentsTracking('CTA Clicked', {
      pageTitle: 'Maximo Journey Advisor Assessment',
      object: 'Maximo Journey Advisor Page',
      resultValue: 'CTA clicked',
      CTA: `${value} radio button`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  useEffect(() => {
    if (que1Value) {
      setIsRequired(false);
    }
  }, []);

  return (
    <div className="step">
      <div className="page_heading_3 mt-01">
        <FormattedMessage {...messages.question1_title} />
      </div>
      <div className="bx--row">
        <div className="bx--col-lg-8 bx--col-md-6 bx--col-sm-4">
          <RadioButtonGroup
            name="Q1-primary-industry"
            defaultSelected="Q1A1"
            valueSelected={que1Value}
            orientation="vertical"
            className="mar2"
          >
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt1)}
              value={primaryIndustryOption.opt1}
              id="Q1A1"
              onClick={(event) =>
                handleClick(primaryIndustryOption.opt1, event)
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt2)}
              value={primaryIndustryOption.opt2}
              id="Q1A2"
              onClick={(e) => handleClick(primaryIndustryOption.opt2, e)}
            />
            <div className="tooltip1">
              <Tooltip
                onChange={() => {
                  segmentsTracking('CTA Clicked', {
                    pageTitle: 'Maximo Journey Advisor Assessment',
                    object: 'Maximo Journey Advisor Assessment page',
                    resultValue: 'CTA clicked',
                    CTA: 'Government tooltip',
                    location: `Assessment`,
                    action: '',
                    field: '',
                  });
                }}
                className="maximo-tooltip"
                direction={'top'}
                tabIndex={0}
                showIcon={true}
                triggerText={''}
              >
                <span className="slide_text">
                  <FormattedMessage {...messages.question1_opt2_tooltipInfo} />
                </span>
              </Tooltip>
            </div>
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt3)}
              value={primaryIndustryOption.opt3}
              id="Q1A3"
              className="radio-mar-top"
              onClick={(e) => handleClick(primaryIndustryOption.opt3, e)}
            />
            <div className="tooltip2">
              <Tooltip
                onChange={() => {
                  segmentsTracking('CTA Clicked', {
                    pageTitle: 'Maximo Journey Advisor Assessment',
                    object: 'Maximo Journey Advisor Assessment page',
                    resultValue: 'CTA clicked',
                    CTA: 'Manufacturing tooltip',
                    location: `Assessment`,
                    action: '',
                    field: '',
                  });
                }}
                className="maximo-tooltip"
                direction={'top'}
                tabIndex={0}
                showIcon={true}
                triggerText={''}
              >
                <span className="slide_text">
                  <FormattedMessage {...messages.question1_opt3_tooltipInfo} />
                </span>
              </Tooltip>
            </div>
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt4)}
              value={primaryIndustryOption.opt4}
              className="radio-mar-top"
              id="Q1A4"
              onClick={(e) => handleClick(primaryIndustryOption.opt4, e)}
            />
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt5)}
              value={primaryIndustryOption.opt5}
              id="Q1A5"
              onClick={(e) => handleClick(primaryIndustryOption.opt5, e)}
            />
            <div className="tooltip3">
              <Tooltip
                onChange={() => {
                  segmentsTracking('CTA Clicked', {
                    pageTitle: 'Maximo Journey Advisor Assessment',
                    object: 'Maximo Journey Advisor Assessment page',
                    resultValue: 'CTA clicked',
                    CTA: 'Travel and Transportation tooltip',
                    location: `Assessment`,
                    action: '',
                    field: '',
                  });
                }}
                className="maximo-tooltip"
                direction={'top'}
                tabIndex={0}
                showIcon={true}
                triggerText={''}
              >
                <span className="slide_text">
                  <FormattedMessage {...messages.question1_opt5_tooltipInfo} />
                </span>
              </Tooltip>
            </div>
            <RadioButton
              labelText={intl.formatMessage(messages.question1_opt6)}
              value={primaryIndustryOption.opt6}
              id="Q1A6"
              onClick={(e) => handleClick(primaryIndustryOption.opt6, e)}
              className="radio-mar-top"
            />
          </RadioButtonGroup>
        </div>
        {q1Img && (
          <div className="bx--col-lg-8 bx--col-md-6 bx--col-sm-4 img-mar1">
            <PublicImage
              imgPath={q1Img}
              widgetId="maximo-journey-advisor"
              id="q1Img"
              alt="Que1 picture"
              className="imgStyle"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Step1;
